import React from 'react';
import './highlightText.css';
function HighlightText(props) {


    return (
        <>
            <svg width='0' height='0'>
                <defs>
                    <linearGradient x1={'0%'} y1={'0%'} x2={'100%'} y2={'0%'} id='gestureGradient'>
                        <stop stopColor='#5aa8f8' offset='0%'/>
                        <stop stopColor='#3c61f6' offset='33%'/>
                        <stop stopColor='#9474f5' offset='66%'/>
                        <stop stopColor='#c68ac0' offset='100%'/>
                    </linearGradient>
                </defs>
            </svg>
            <div className={"highlight-text"}>
                {props.children}
            </div>
        </>
)
    ;
}

export default HighlightText;